import React, { forwardRef } from "react"
import PropTypes from "prop-types"
import cn from "classnames"
import injectTooltip from "./injectTooltip"
import styles from "./styles.css"

const TooltipWrapper = injectTooltip(
  forwardRef(({ children, className, tooltip, ...other }, ref) => (
    <span ref={ref} className={cn(className, styles.tooltipWrapper)} {...other}>
      {tooltip}
      {children}
    </span>
  )),
)

TooltipWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  tooltip: PropTypes.node,
}

TooltipWrapper.defaultProps = {
  children: null,
  className: ``,
  tooltip: null,
}

export default TooltipWrapper
